<div
  #toastWrap
  id="toast-stack-wrap"
  class="fixed top-16 left-2.5 right-2.5 z-[999]  pointer-events-none"
  [style.marginTop.px]="toastMarginTopPx"
>
  <div
    #toastStack
    id="toast-stack"
    class="relative pointer-events-auto transition-[height] duration-350"
  ></div>
  <div
    #countPill
    id="count-pill"
    class="absolute -top-2 -right-1.5   bg-blue-theme-color text-white-color text-[10px] font-semibold rounded-full px-2 py-0.5 opacity-0 scale-75 transition-all duration-200 pointer-events-none z-10"
  >
  </div>
</div>
